import React, { useState } from 'react';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import './AIChat.css';

const AIChat = () => {
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        const userMessage = input.trim();
        setInput('');
        setIsLoading(true);

        // Add user message to chat
        setMessages(prev => [...prev, { text: userMessage, sender: 'user' }]);

        try {
            console.log('Calling chat_with_ai function with message:', userMessage);
            const chat_with_ai = httpsCallable(functions, 'chat_with_ai');
            
            // Match the parameter name with your Cloud Function
            const result = await chat_with_ai({ userprompt: userMessage });
            console.log('Received response:', result);
            
            // Add AI response to chat
            setMessages(prev => [...prev, { text: result.data.response, sender: 'ai' }]);
        } catch (error) {
            console.error('Detailed error:', error);
            setMessages(prev => [...prev, { 
                text: `Error: ${error.message || 'Unknown error occurred'}`, 
                sender: 'ai' 
            }]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="ai-chat-container">
            <h2>Chat with AI</h2>
            
            <div className="ai-chat-description">
                <p>This is a chat interface with Chat GPT's API. You can use it in the same way for queries. 
                This interface is in its baby phase and I look to build it out by training it on the contents 
                of the website as they emerge and potentially other items in an effort to AI clone myself 
                for efficiency capabilities.</p>
            </div>
            
            <div className="chat-messages">
                {messages.map((message, index) => (
                    <div key={index} className={`message ${message.sender}`}>
                        {message.text}
                    </div>
                ))}
                {isLoading && (
                    <div className="message ai loading">
                        Thinking...
                    </div>
                )}
            </div>
            <form onSubmit={handleSubmit} className="chat-input-form">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Type your message..."
                    disabled={isLoading}
                />
                <button type="submit" disabled={isLoading || !input.trim()}>
                    Send
                </button>
            </form>
        </div>
    );
};

export default AIChat;
